import {
  EuqFeedbackContentReqDto,
  EuqFeedbackDownloadReqDto,
  EuqFeedbackRecord,
  FeedbackRelatedEntryResponse,
  FeedbackRelatedEntryReqDto,
  FeedbackResultData,
  FeedbackMailData,
} from '@Quarantine/UserReportedEmails/type';
import request from '@Utils/request';
import { AxiosPromise } from 'axios';
import { LogData } from '@Types/log';
import { QuarantineLogContentReqDto } from '@Quarantine/utils/types';

function apiGetEuqContentList(
  filterParams: EuqFeedbackContentReqDto
): AxiosPromise<{
  contentList: EuqFeedbackRecord[];
  total: number;
}> {
  return request({
    method: 'post',
    url: 'euqFeedBack/contents',
    data: filterParams,
  });
}

function apiExportEuqContentList(
  filterParams: EuqFeedbackContentReqDto
): AxiosPromise<{
  contentList: EuqFeedbackRecord[];
  total: number;
}> {
  return request({
    method: 'post',
    url: 'euqFeedBack/export',
    data: filterParams,
  });
}

function apiDownloadEuqFeedBack(data: EuqFeedbackDownloadReqDto) {
  return request({
    method: 'post',
    url: 'euqFeedBack/download',
    data,
    timeout: 5 * 60 * 1000,
    responseType: 'blob',
  });
}
function apiGetEuqFeedbackStatistic(params: {
  predefined: string;
  dimension:
    | 'category'
    | 'status'
    | 'result_category'
    | 'mitigation_status'
    | 'request_source'
    | 'service_type';
}): AxiosPromise<any> {
  return request({
    url: 'euqFeedBack/statistics',
    method: 'get',
    params,
  });
}

function apiBatchApproveEuqFeedback(data: string[]): AxiosPromise<any> {
  return request({
    url: 'euqFeedBack/feedback',
    method: 'post',
    data: data.map((item) => {
      return {
        id: item,
        action: 'approve',
      };
    }),
  });
}

function apiBatchRejectEuqFeedback(data: string[]): AxiosPromise<any> {
  return request({
    url: 'euqFeedBack/feedback',
    method: 'post',
    data: data.map((item) => {
      return {
        id: item,
        action: 'reject',
      };
    }),
  });
}

function apiGetManualApproveConfig(orgId: string): AxiosPromise<boolean> {
  return request({
    method: 'get',
    url: 'euqFeedBack/manualApprove',
    headers: {
      'x-org-id': orgId,
    },
  });
}

function apiGetRiskAiContentList(
  params: QuarantineLogContentReqDto
): AxiosPromise<LogData> {
  return request({
    url: `quarantine/riskAi/contentList`,
    method: 'get',
    params,
  });
}

function apiTriggerRiskAiContentListExport(
  data: QuarantineLogContentReqDto
): AxiosPromise<any> {
  return request({
    url: `quarantine/riskAi/tasks/export`,
    method: 'post',
    data,
  });
}

function apiGetFeedbackRelatedEntries(
  companyGuid: string,
  feedbackId: string,
  params: FeedbackRelatedEntryReqDto
): AxiosPromise<FeedbackRelatedEntryResponse> {
  return request({
    url: `euqFeedBack/${companyGuid}/${feedbackId}`,
    method: 'post',
    data: params,
  });
}

function apiGetFeedbackResult(
  companyGuid: string,
  feedbackId: string
): AxiosPromise<FeedbackResultData> {
  return request({
    url: `euqFeedBack/${companyGuid}/${feedbackId}/result`,
    method: 'get',
  });
}

function apiGetFeedbackMail(
  companyGuid: string,
  feedbackId: string
): AxiosPromise<FeedbackMailData> {
  return request({
    url: `euqFeedBack/${companyGuid}/${feedbackId}/mail`,
    method: 'get',
  });
}

function apiExecuteFeedbackActions(
  companyGuid: string,
  feedbackId: string,
  actionIds: string[]
): AxiosPromise<any> {
  return request({
    url: `euqFeedBack/${companyGuid}/${feedbackId}/execute`,
    method: 'post',
    data: actionIds.map((id) => ({ id })),
  });
}

export default {
  apiGetEuqContentList,
  apiExportEuqContentList,
  apiDownloadEuqFeedBack,
  apiGetEuqFeedbackStatistic,
  apiBatchApproveEuqFeedback,
  apiBatchRejectEuqFeedback,
  apiGetManualApproveConfig,
  apiGetRiskAiContentList,
  apiTriggerRiskAiContentListExport,
  apiGetFeedbackRelatedEntries,
  apiGetFeedbackResult,
  apiGetFeedbackMail,
  apiExecuteFeedbackActions,
};
